import { HttpBackend, HttpClient } from "@angular/common/http";
import { Observable, Subject } from "rxjs";
import { ElasticResponseInterface, WagtailSearchResultItemInterface } from "./models";
import { inject, Injectable } from "@angular/core";
import { ProductCollection } from "@gea-waldviertler-website/gea-models";
import { EnvService } from "@gea-waldviertler-website/shop-lib";

@Injectable()
export class ElasticsearchService {
  private productCollectionChangeSubject: Subject<ProductCollection | undefined>
  private keyboardNavigationIndexChangeSubject: Subject<number>
  private cmsSearchResultsChangeSubject: Subject<WagtailSearchResultItemInterface[] | undefined>
  private callSelectionSubject: Subject<number>
  private toggleSearchSubject: Subject<boolean>

  private envService = inject(EnvService)

  constructor(
    private http: HttpClient, backend: HttpBackend,
  ) {
    this.http = new HttpClient(backend)
    this.productCollectionChangeSubject = new Subject<ProductCollection | undefined>()
    this.keyboardNavigationIndexChangeSubject = new Subject<number>()
    this.cmsSearchResultsChangeSubject = new Subject<WagtailSearchResultItemInterface[] | undefined>()
    this.callSelectionSubject = new Subject<number>
    this.toggleSearchSubject = new Subject<boolean>
  }

  public getProductCollection() {
    return this.productCollectionChangeSubject
  }

  public getKeyboardNavigationIndex() {
    return this.keyboardNavigationIndexChangeSubject
  }

  public getCmsSearchResults() {
    return this.cmsSearchResultsChangeSubject
  }

  public getCallSelectionEvent() {
    return this.callSelectionSubject
  }

  public getToggleSearchSubject() {
    return this.toggleSearchSubject
  }

  query(sword: string): Observable<ElasticResponseInterface> {
    sword = sword.toLowerCase()
    return this.http.post<ElasticResponseInterface>(this.envService.config.elasticsearchUrl + '_search', {
      from: 0,
      size: 12,
      query: {
        bool: {
          should: [{
            "match": {
              "titlePrefix": {
                "query": sword,
                "boost": 150.0,
              }
            }
          }, {
            "match": {
              "titleInfix": {
                "query": sword,
                "boost": 50.0,
              }
            }
          }, {
            "wildcard": {
              "titlews": {
                "value": sword + '*',
                "boost": 2.0,
              }
            }
          }, {
            "fuzzy": {
              "title": {
                "value": sword,
                "fuzziness": 2,
                "boost": 2.0,
              }
            }
          }, {
            "match": {
              "titlews": {
                "operator" : "OR",
                "query": sword,
                "boost": 2.0,
              }
            }
          }, {
            "match": {
              "titlews": {
                "operator" : "AND",
                "query": sword,
                "boost": 4.0,
              }
            }
          }, {
            "wildcard": {
              "categories": {
                "value": sword + '*',
                "boost": 1.0,
              }
            }
          }, {
            "fuzzy": {
              "categories": {
                "value": sword,
                "fuzziness": 2,
                "boost": 2.0,
              }
            }
          }, {
            "fuzzy": {
              "shortDescription": {
                "fuzziness": 2,
                "value": sword,
                "boost": 1.0,
              }
            }
          }, {
            "fuzzy": {
              "description": {
                "value": sword,
                "boost": 1.0,
              }
            }
          }]
        }
      }
      // "suggest": {
      //   "text" : sword,
      //   "all": {
      //     "term" : {
      //       "field": "title",
      //       "analyzer": "keyword",
      //     }
      //   },
      // }
    })
  }
}
